
var socialShareLoaded = false;
var menuSignInClicked = false;
var isMobile = false;
var isBlogContent = false;
var isVideo;
var UserEmailAddress;
//#region CallWebServices

function CallService(url, data, isAsync, successFunction) {
    var baseServiceURL = '';
    //If only the function name is specified set the base service url to the default service
    var returnMessage;
    $.ajax(
        {
            type: "POST", //GET or POST or PUT or DELETE verb
            url: baseServiceURL + url, // Location of the service
            data: JSON.stringify(data), //Data sent to server
            contentType: "application/json; charset=utf-8", // content type sent to server
            dataType: "json", //Expected data format from server
            async: isAsync, //True or False
            success: function (msg) {//On Successfull service call
                if (successFunction != '') {
                    eval(successFunction + '(msg);');
                }
                else {
                    returnMessage = msg;
                }
            },
            error: ServiceFailure
        });
    return returnMessage;
}

function ServiceFailure(result) {
    ShowNotificationMsg(result.statusText, 'Error');
}

//#endregion


function MasterReady() {


    (function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|android|playbook|silk|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);

    if (jQuery.browser.mobile == true)
        isMobile = true;

    SetFollowUsLinks();
    SetSocialShareLinks();
    HandleSpecialClasses();
}

function SetMenu() {
    $(".megaMenu").append($("#megaMenuContent").val());
    $(".seconaryNavigation").append($("#headerNavigationContent").val());
    $(".footer").prepend($("#footerdataContent").val());
}

function ShowNotificationMsg(msg, notificationType) {

    if (notificationType == 'Success')
        notificationType = 0;
    else if (notificationType == 'Error')
        notificationType = 1;

    var notification = {
        "Message": msg,
        "NotificationType": notificationType
    }
    ShowNotification(notification);
}

function ShowNotification(notification) {
    console.log(notification);
    if (notification.Message == '') return;

    if (notification.NotificationType == 1) {//error
        //if there is already error displayed on the UI, return. Multiple errors may result when multiple calls are made to the web services
        if ($('#divErrorMsg').length > 0) return;

        var header = $("#contentHeader").html();
        header = $.trim(header);
        if (header == '')
            header = "Error";
        var errorMsg = '<div id="divErrorMsg"><h1>' + header + '</h1>';
        errorMsg += '<div class="contentBlock required"><p>' + notification.Message + '</p></div></div>';
        //in case of error msg hide the main content block. This is because user might have to go back to the actual content. For example
        //in case of registration user might want to re-enter the user/email in case it already existed in the system
        $("#mainCont").hide();

        //prepend the error message to the main div cCont. cCont contains the mainCont div
        $("#cCont").removeClass("hide");
        $("#cCont").prepend(errorMsg).hide().fadeIn('slow');
    }
    else {
        var header = $("#contentHeader").html();
        header = $.trim(header);
        if (header == '')
            header = "Confirmation";
        var confirmationMsg = '<h1>' + header + '</h1>';
        confirmationMsg += '<div class="contentBlock"><p>' + notification.Message + '</p></div>';
        $("#mainCont").hide();
        $("#cCont").removeClass("hide");
        $("#cCont").html(confirmationMsg).hide().fadeIn('slow');
    }
}

function ShowNotificationPopUp(notification, callback) {
    if (notification.Message == '') return;

    if ($("#divPopUpNotification").length > 0) {
        $("#divPopUpNotification").remove();
    }
    var errorClass = '';
    var header = 'Success';
    if (notification.NotificationType == 1) {
        errorClass = 'required';
        header = 'Error';
    }

    if (callback) {
        callback = callback + "();";
    }
    else { callback = ""; }

    var $popupDialog = $('<div />', { 'id': 'divPopUpNotification' }).append(
        $('<img />', { 'src': '/Air/Assets/Images/Icons/delete.png', 'style': 'cursor: pointer; float: right;', 'onclick': '$("#divPopUpNotification").dialog("close");' + callback })).append(
            $('<h3 />', { 'html': header + '<hr />' })).append(
                $('<div />', { 'style': 'padding:5px; vertical-align:middle;', 'class': errorClass, 'html': notification.Message }));

    $popupDialog.dialog(
        {
            autoOpen: true,
            modal: true,
            resizable: false
        });

    $('.ui-dialog').addClass('modalDialog');
    $('.ui-dialog').addClass("shadow");

}

function ShowNotificationPopUpMsg(msg, notificationType) {

    if (notificationType == 'Success')
        notificationType = 0;
    else if (notificationType == 'Error')
        notificationType = 1;

    var notification = {
        "Message": msg,
        "NotificationType": notificationType
    }
    ShowNotificationPopUp(notification);
}

//the function is called if there is a link in the error message to display back the actual content the user was on.
function ShowContentAfterError() {

    //first remove the error message that was displayed
    $("#divErrorMsg").remove();

    //show the original content
    $("#mainCont").fadeIn('slow');
}


var imgDomainPrefix = ""; //To do: Remove THIS and all references or just set to blank!!
function GetFullImageSource(image) {
    return imgDomainPrefix + image;
}

//#region Social

function AddVirtualViewInAnalytics(url) {
    var fullUrl = location.protocol + '//' + location.hostname + url;
    //google

    //_gaq.push(['_trackPageview', url]);

    //ga('send', 'pageview', url.toLowerCase());

    //eloqua
    //if (typeof _elq !== 'undefined') {
    //    _elq.trackEvent(fullUrl);
    //}

}

//#region Follow Us
function SetFollowUsLinks() {
    var followUs = $(".divFollowUs").html();
    $(".footerMenu").append(followUs);
}
$(".followTwitter").on("click", function () {
    var analyticsURL = location.pathname + 'Follow-Twitter/';
    AddVirtualViewInAnalytics(analyticsURL);
});

$(document).on("click", ".pdfTracking", function () {
    var analyticsURL = $(this).attr("href").toLowerCase();
    AddVirtualViewInAnalytics(analyticsURL);
});

//#endregion

//#region Set/Load/Show/Hide Social Sharing Links in the Share bar
function SetSocialShareLinks() {
    if ($('#socialShare').val() == "true" || $("#showFeedbackForm").val() == "true") {

        if ($("#contentBlock").parent().attr("id") == "pageContent") {
            var withHeader = false;
            $("#contentBlock").children().each(function () {
                if ($(this).hasClass("pageHeader")) {
                    $(this).next(".container").prepend('<div class="socialShareButtonsContainer"></div>').css("position", "relative");

                    if ($(".commonTitle").html()) {
                        if ($(".commonTitle").html().toLowerCase() == "press release")
                            $(this).next(".container").find(".whiteBarSpacing").addClass("pressReleaseSocialShare");
                    }
                    withHeader = true;
                }

                if ($(this).hasClass("contentBlock")) {
                    $('.col-md-gutter').children().each(function () {
                        if ($(this).hasClass("pageHeader")) {
                            $(this).next(".container").prepend('<div class="socialShareButtonsContainer"></div>').css("position", "relative");

                            if ($(".commonTitle").html()) {
                                if ($(".commonTitle").html().toLowerCase() == "press release")
                                    $(this).next(".container").find(".whiteBarSpacing").addClass("pressReleaseSocialShare");
                            }
                            withHeader = true;
                        }
                    });
                }
            });

            if (withHeader == false) {
                $("#contentBlock .container:first-child").prepend('<div class="socialShareButtonsContainer"></div>');
            }
        } else {
            var withHeader = false;
            $("#pageContent").children().each(function () {
                if ($(this).hasClass("pageHeader") || $(this).hasClass("medBlueBg")) {
                    $(this).next(".container").prepend('<div class="socialShareButtonsContainer test1"></div>').css("position", "relative");

                    if ($(".commonTitle").html().toLowerCase() == "press release")
                        $(this).next(".container").find(".whiteBarSpacing").addClass("pressReleaseSocialShare");
                    withHeader = true;
                }
            });
            if (withHeader == false) {
                $("#pageContent .container:first-child").prepend('<div class="socialShareButtonsContainer"></div>');
            }
        }
        $("#contentBlock > .container:last-child").append('<div id="divShareEmail"></div>');
        $(".socialShareButtonsContainer").load("/Air/Assets/Html/SocialShareButtons.html");
    }

    if ($("#showFeedbackForm").val() == "true") {
        $("#contentBlock > .container:last-child").append('<div id="divFeedbackForm"></div>');
    }
}

function HandleSpecialClasses() {

    $(".dataTab").show();

    $('.collapsibleContent').each(function (idx, item) {
        var collapse = "false";
        var input = 0;
        input = parseInt($(item).data('expand'), 0);
        if (input == '0')
            collapse = "false";
        else
            collapse = input - 1;

        $(item).accordion({
            collapsible: true,
            active: collapse,
            heightStyle: "content"
        });

        $(item).removeClass('hide');
    });
}


//end content video


//the function gets the query string value in case they're aliased. 
//Example dev.air-worldwide.com/FacetSearch/Text/flood/. The query string is Text and the value is flood
//Passing text as argument to this function will return value flood
function GetQueryStringAliasedURL(query) {
    var items = location.href.split('/');

    for (x = 0; x < items.length; x++) {

        if (items[x].toLowerCase() == query.toLowerCase())
            return decodeURI(items[x + 1]);
    }
}


function GetDate(date) {
    if (typeof (date) == "string") {
        var dateReg = /[0-9]+/;
        if (dateReg.test(date))
            return new Date(parseInt(date.match(dateReg)[0]));
        else
            date.toString();
    }
}

function FormatDate(dateValue, stringFormat) {
    var date = GetDate(dateValue);
    return dateFormat(date, stringFormat);
}


function CheckMaxLength(id, length) {
    var field = document.getElementById(id);
    if (field) {
        if (field.value.length >= length)
            field.value = field.value.substring(0, length);
    }
}


function GetValidationRules(pageName) {
    return CallService("GetValidationRules", { "pageName": pageName.toLowerCase() }, false, "").GetValidationRulesResult;
}

//if we need to validate fields that might be hidden pass in the classname. This is the case for example when using tab or accordion control.
//in such a case add a classname to the fields and the function will validate based on the class name instead of the visibility.
function Validate(action, validationRules, validationClassName) {
    if (validationClassName === undefined) {
        validationClassName = '';
    }
    var isValid = true;
    var value;
    ClearErrorMessages();

    for (var i = 0; i < validationRules.length; i++) {
        if (validationRules[i].Action == action) {
            var validationRule = validationRules[i];

            for (var j = 0; j < validationRule.Fields.length; j++) {
                $(validationRule.Fields[j].Selector).each(function (i) {
                    //only check for validation of the element when it's visible
                    if (ValidateField(this, validationClassName)) {
                        value = $.trim(this.value);
                        if (!value.match(validationRule.Fields[j].Test)) {
                            var fieldToValidate = validationRule.Fields[j].Selector;
                            $(this).addClass("required");
                            if (validationRule.Fields[j].Message != '') {
                                $(fieldToValidate).parent().append("<div class='required'>" + validationRule.Fields[j].Message + "</div>");
                            }
                            isValid = false;
                        }
                    }
                });
            }
        }
    }
    return isValid;
}

function ValidateField(field, validationClassName) {
    //validate based on visibility
    if (validationClassName == '') {
        return $(field).is(":visible");
    }
    else {
        //validate based on class name
        return $(field).hasClass(validationClassName);
    }
}


function ClearErrorMessages() {
    $.each($("input[class*='required']"), function (i, v) {
        $(v).removeClass("required");
    });

    $.each($("select[class*='required']"), function (i, v) {
        $(v).removeClass("required");
    });

    $.each($("textarea[class*='required']"), function (i, v) {
        $(v).removeClass("required");
    });

    $.each($("div[class*='required']"), function (i, v) {
        $(v).remove();
    });

    $.each($("span[class*='required']"), function (i, v) {
        $(v).remove();
    });

}


function IsUserLoggedIn() {
    if ($("#IsLoggedIn").val() == "true")
        return true;
    else
        return false;
}

function GetEloquaInfo() {
    var eloqua = { CustomerGUID: eloquaCustomerGUID, CookieWrite: "0" };
    return eloqua;
}

//#endregion

//function SearchClicked() {

//    var searchText = $("#txtSearch").val();
//    searchText = $.trim(searchText);
//    searchText = searchText.replace(/(<([^>]+)>)/ig, "");

//    if (searchText == "Search")
//        searchText = "";

//    //store the search text in the session and redirect to the facet search page. The facet 
//    //search page gets the search term from the session. 
//    sessionStorage.SearchText = searchText;

//    ClearSearchDataCookie();
//}

function ClearSearchDataCookie() {
    sessionStorage.removeItem('FacetSearchData');
}


$(document).keyup(function (event) {

    if (event.keyCode == 13) {//enter key
        //when the user is the search textbox 
        if ($("input:focus").attr("id") == 'txtSearch') {
            //SearchClicked();
            submitSearchForm();
            return false;
        } else {
            return false;
        }
        //when user is in the pager textbox
        //else if ($("input:focus").attr("id") == 'txtGoToPage') {
        //    PagerGoToClick(); //function is in Pager.ascx
        //    return false;
        //} else if ($("input:focus").attr("id") == 'subscribeBlogEmailAddressFooter') {
        //    $("#subscribeBlogEmailAddressFooter").blur();
        //    ProcessEmailSubscribe();
        //    return false;
        //} else if ($("input:focus").attr("id") == 'txtSubscribeBlogEmailAddress') {
        //    var thisElement = $("#txtSubscribeBlogEmailAddress").next();
        //    ProcessEmailSubscribe(thisElement);
        //    return false;
        //} else if ($("input:focus").attr("id") == 'txtSubscribeBlogEmailAddressBottom') {
        //    var thisElement = $("#txtSubscribeBlogEmailAddressBottom").next();
        //    ProcessEmailSubscribe(thisElement);
        //    return false;
        //}
    }
});


/* Dialog Box */


function ShowLoadingDialog() {
    console.log("loading...");
    $('#divLoading').removeClass('hide');
    $('#divLoading').dialog({
        autoOpen: false,
        width: 300,
        height: 150,
        modal: true,
        resizable: false
    });
    $('.ui-dialog').addClass('modalDialog');
    $('.ui-dialog').addClass("shadow");
    $('#divLoading').dialog('open');
}

function HideLoadingDialog() {
    console.log("loading stop");
    $('#divLoading').dialog('close');
    $('#divLoading').addClass('hide');
}

function ShowConfirmationDialog() {
    OpenConfirmationDialog();
    $('#subscriptionConfirmDiv').removeClass('hide');
}

function ShowSubscribeErrorDialog() {
    OpenConfirmationDialog();
    $('#subscriptionErrorDiv').removeClass('hide');
}

function ShowAlreadySubscribedDialog(email) {
    OpenConfirmationDialog();
    $('#alreadySubscribedEmail').text(email);
    $('#alreadySubscribedDiv').removeClass('hide');
}

function ShowBlogRecaptchaDialog() {
    OpenConfirmationDialog();

    $('#recaptchaVerify').removeClass('hide');
}

function OpenConfirmationDialog() {
    $('#dialogConfirmation').removeClass('hide');
    $('#dialogConfirmation').dialog({
        autoOpen: false,
        width: 480,
        height: 120,
        modal: true,
        resizable: false
    }).dialog('open');
    $('.ui-dialog').addClass('modalDialog');
    $('.ui-dialog').addClass("shadow");
    $('#subscriptionConfirmDiv').addClass('hide');
    $('#alreadySubscribedDiv').addClass('hide');
    $('#subscriptionErrorDiv').addClass('hide');
    $('#recaptchaVerify').addClass('hide');

}

function HideConfirmationDialog() {
    $('#dialogConfirmation').dialog({
        autoOpen: false,
        width: 480,
        height: 120,
        modal: true,
        resizable: false
    }).dialog('close');
    $('#dialogConfirmation').addClass('hide');
}

//#region ServerSessionFunctions

function SetSession(name, data) {
    CallService("SetSessionObject", { "name": name, "data": data }, false, "");
}

function RemoveSession(name) {
    CallService("RemoveSessionObject", { "name": name }, false, "");
}

function GetSession(name) {
    return CallService("GetSessionObject", { "name": name }, false, "").GetSessionObjectResult;
}

function GetSessionAndRemove(name) {
    return CallService("GetSessionObjectAndRemove", { "name": name }, false, "").GetSessionObjectAndRemoveResult;
}

//#endregion

/* Blog Subscription for common footer and blog page */
var blogRightNav;
var blogBottom;
function ProcessEmailSubscribe(el) {

    //dataLayer.push({ 'event': 'BlogSubscribe' });
    if ($(el).data("content") == "blog") {
        blogRightNav = true;
    } else if ($(el).data("content") == "blogbottom") {
        blogBottom = true;
    }

    CheckBlogsSubscriptionFromEloqua();

}

function CheckBlogsSubscriptionFromEloqua() {
    var data = "";
    if (blogRightNav == true) {
        data = { "eloquaEmail": $('#txtSubscribeBlogEmailAddress').val(), "eloquaInfo": GetEloquaInfo() };
    } else if (blogBottom == true) {
        data = { "eloquaEmail": $('#txtSubscribeBlogEmailAddressBottom').val(), "eloquaInfo": GetEloquaInfo() };
    } else {
        data = { "eloquaEmail": $('#subscribeBlogEmailAddressFooter').val(), "eloquaInfo": GetEloquaInfo() };
    }

    if (data["eloquaEmail"] != "") {
        ShowLoadingDialog();
        CallService("/api/air/GetUserBlogSubscriptionStatus", data, true, "GetUserBlogSubscriptionStatusComplete");
    }

}

function GetUserBlogSubscriptionStatusComplete(result) {
    if (result) {
        HideLoadingDialog();
        if (blogRightNav == true) {
            ShowAlreadySubscribedDialog($('#txtSubscribeBlogEmailAddress').val());
        } else {
            ShowAlreadySubscribedDialog($('#subscribeBlogEmailAddressFooter').val());
        }
    }
    else {
        HideLoadingDialog();
        ShowBlogRecaptchaDialog();
    }
}


function SubmitBlogsSubscriptionToEloqua() {
    var data = "";
    if (blogRightNav == true) {
        data = { "emailAddress": $('#txtSubscribeBlogEmailAddress').val(), "status": "pending", "eloquaInfo": GetEloquaInfo(), FormName: "AIR Blog Subscription Form", CaptchaBlogResponse: $('#CaptchaBlogResponse').val() };
    } else if (blogBottom == true) {
        data = { "emailAddress": $('#txtSubscribeBlogEmailAddressBottom').val(), "status": "pending", "eloquaInfo": GetEloquaInfo(), FormName: "AIR Blog Subscription Form", CaptchaBlogResponse: $('#CaptchaBlogResponse').val() };
    } else {
        data = { "emailAddress": $('#subscribeBlogEmailAddressFooter').val(), "status": "pending", "eloquaInfo": GetEloquaInfo(), FormName: "AIR Blog Subscription Form", CaptchaBlogResponse: $('#CaptchaBlogResponse').val() };
    }
    CallService("/api/air/SubmitBlogsSubscriptionToEloqua", data, true, "SubmitBlogsSubscriptionToEloquaComplete");
}

function SubmitBlogsSubscriptionToEloquaComplete(result) {
    HideLoadingDialog();
    if (result)
        ShowConfirmationDialog();
    else
        ShowSubscribeErrorDialog();
}

function ExistsInArray(array, value) {
    if (array.indexOf(value) > -1)
        return true;
    else
        return false;
}

//#region DataServices

function DataServicesLayerKeyUp(type, id) {

    if (type == 'Limit') {
        value = $('#' + id).val();
    }
    else if (type == 'Excess') {
        value = $('#' + id).val();
    }
    else if (type == 'Signed') {
        value = $('#' + id).maskMoney('unmasked')[0];
        if (parseFloat(value) > 100) {
            $('#' + id).val('100.00%');
        }
    }

}

function DataServicesValidateLayer(isRemodel) {
    var layers = new Array();
    var invalidLayers = false;
    $(".layerRows").each(function () {
        var limitText = $.trim($('input[id^="limit_"]', $(this)).val());
        var excessText = $.trim($('input[id^="excess_"]', $(this)).val());
        var singedLineText = $.trim($('input[id^="signed_"]', $(this)).val());
        var perilsText = $.trim($('input[id^="perils_"]', $(this)).val());

        //if all three textboxes are empty simply ignore the layer
        if (limitText == "" && (excessText == "" || excessText == "0") && singedLineText == "" && perilsText == "") {
            return true;
        }

        if (limitText == "") {
            invalidLayers = true;
            $('input[id^="limit_"]', $(this)).addClass('required');
        }


        if (singedLineText == "") {
            invalidLayers = true;
            $('input[id^="signed_"]', $(this)).addClass('required');
        }

        //only add layer if all three fields are valid
        if (limitText != "" && singedLineText != "") {
            layers.push({ Limit: limitText, Excess: excessText, SignedLine: singedLineText, Perils: perilsText, IsRemodel: isRemodel });
        }
    });

    return { "Layers": layers, "InvalidLayers": invalidLayers };

}

//#endregion

function sendEmail(oldEmail, newEmail, callback) {
    CallService("SendUpdatedEmailNotificationToAdmin", { "oldEmail": oldEmail, "newEmail": newEmail }, true, callback);
}

function Decode(encoded) {
    return $("<textarea/>").html(encoded).text();
}


function DecodeAllInputs() {
    $("input[type='text'], textarea").each(function () {
        $(this).val($("<textarea/>").html($(this).val()).text());
    });
}


function LoadLoginSelectEmailForm(data) {
    //check to see if the html content is already loaded
    if ($('#dialogLoginSelectEmail').length == 0) {
        //passing datetime now to the html page as data will ensure it's not getting it from cache
        $('#divLoginSelectEmail').load('/Html/LoginSelectEmail.htm?datetime=' + $.now().toString(), function () { ShowLoginSelectEmail(data); });
    }
    else {
        //function in LoginSelectEmail.htm 
        ShowLoginSelectEmail(data);
    }
}

function GetUserProfileComplete(result) {

    if (result.GetUserProfileResult.FirstName != "" && result.GetUserProfileResult.LastName != "") {
        var fullName = result.GetUserProfileResult.FirstName + " " + result.GetUserProfileResult.LastName;
        $("#fullName").val(fullName);
    }

    if (result.GetUserProfileResult.EmailAddress != "") {
        UserEmailAddress = result.GetUserProfileResult.EmailAddress;
        $("#feedbackEmail").val(UserEmailAddress);
    }

    CheckCommentNotificationSubscription(UserEmailAddress);
}

function CheckCommentNotificationSubscription(email) {
    CallService("CheckCommentNotificationSubscription", { "contentId": contentId, "email": email }, true, "CheckCommentNotificationSubscriptionComplete");
}

function CheckCommentNotificationSubscriptionComplete(result) {
    $(".commentSubscription").css("display", "inline-block");
    if (result.CheckCommentNotificationSubscriptionResult == true) {
        $(".commentSubscription").html("<p class='notificationSucess alert alert-success'>You are subscribed for comment notifications with email: " + $("#feedbackEmail").val() + "</p>").removeClass("paleGrayBg").css("padding", "0");
    }
}